/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Direction_PurchaseInputs */

const en_reference_direction_purchase = /** @type {(inputs: Reference_Direction_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchases`)
};

/**
* | output |
* | --- |
* | "Purchases" |
*
* @param {Reference_Direction_PurchaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_direction_purchase = /** @type {((inputs?: Reference_Direction_PurchaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Direction_PurchaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_direction_purchase(inputs)
});